import {
  ValidateRow,
  ValidateRowResult,
} from "@greeter-venue/components/OpeningHoursInput";
import { DailyOpeningHours, WeeklyOpeningHours } from "@greeter/core";
import { every } from "lodash";

export const noEffectWarning = (): ValidateRowResult => ({
  severity: "warning",
  message: "Ingen effekt - du har ikke har åbent den dag",
});

export const earlierThanOpeningHoursFromWarning = (
  ohForDay?: DailyOpeningHours
): ValidateRowResult => ({
  severity: "warning",
  message: `Vær opmærksom på at det er tidligere end åbningstiden kl. ${ohForDay?.from.toString(
    false
  )}`,
});

export const missingArrivalHoursWarning = (): ValidateRowResult => ({
  severity: "warning",
  message:
    "Du har åbent den dag men gæster kan ikke booke hvis du ikke indtaster en tid",
});

export const validateArrivalOpeningHoursRow =
  (
    arrivalOpeningHours: WeeklyOpeningHours,
    openingHours: WeeklyOpeningHours
  ): ValidateRow =>
  ([day, arrOpeningHours]) => {
    // If no fields. Ignore.
    if (
      arrivalOpeningHours &&
      (every(
        [...arrivalOpeningHours.entries()],
        ([day, arrivalOpeningHours]) =>
          arrivalOpeningHours === undefined || !arrivalOpeningHours.isOpen
      ) ||
        [...arrivalOpeningHours.entries()].length === 0)
    ) {
      return undefined;
    }

    const isOpenThatDay = WeeklyOpeningHours.isOpen(openingHours, day);
    const ohForDay = openingHours.get(day);
    const earlierThanOh =
      isOpenThatDay && ohForDay
        ? arrOpeningHours &&
          arrOpeningHours.from.getTotalSeconds() <
            ohForDay.from.getTotalSeconds()
        : false;

    const isClosedButIsOpenThatDay =
      (!arrOpeningHours || !arrOpeningHours.isOpen) &&
      ohForDay &&
      ohForDay.isOpen;

    return !isOpenThatDay && arrOpeningHours && arrOpeningHours.isOpen
      ? noEffectWarning()
      : isOpenThatDay &&
        arrOpeningHours &&
        arrOpeningHours.isOpen &&
        earlierThanOh
      ? earlierThanOpeningHoursFromWarning(ohForDay)
      : isClosedButIsOpenThatDay
      ? missingArrivalHoursWarning()
      : undefined;
  };
